export default function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@popperjs/core/lib/utils/rectToClientRect.js
// module id = 603
// module chunks = 3